// src/pages/ReturnPolicyPage.jsx
// Standalone return policy page, linked from the footer ("Return Policy")
// and used as the return-policy URL declared in Google Merchant Center.
import React from "react";
import "./ContactPage.css";
import Footer from "../Footer";

const ReturnPolicyPage = () => {
  return (
    <div className="cp-root">
      <div className="cp-breadcrumb-bar">
        <div className="cp-breadcrumbs">
          <a href="/">Home</a>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">Return Policy</span>
        </div>
      </div>

      <section className="cp-rfq-section">
        <div className="cp-wrap" style={{ maxWidth: 860 }}>
          <span className="cp-badge">RETURNS</span>
          <h1 style={{ margin: "16px 0 24px", fontSize: "2rem" }}>Return Policy</h1>

          <div style={{ fontSize: "1rem", lineHeight: 1.8, color: "#374151" }}>
            <p>
              BIBA Electronics Pvt Ltd stands behind the quality of every product we ship.
              If an item arrives <strong>defective or not working</strong>, we will replace it
              free of charge.
            </p>

            <h3 style={{ marginTop: 28 }}>Return window</h3>
            <p>
              Report a defective or non-working product within <strong>7 days</strong> of
              delivery by writing to{" "}
              <a href="mailto:info@bibaelectronics.com">info@bibaelectronics.com</a> or
              calling <a href="tel:+919561091506">+91 95610 91506</a>, with your order
              details and a description (or photo/video) of the issue.
            </p>

            <h3 style={{ marginTop: 28 }}>What's covered</h3>
            <p>
              We only replace products that are defective or not working on arrival.
              We do not accept returns for change of mind, incorrect quantity ordered, or
              products that have been used, installed, or damaged after delivery.
            </p>

            <h3 id="cancellations" style={{ marginTop: 28 }}>Cancellations</h3>
            <p>
              All orders are <strong>non-cancellable</strong> once placed, and all items are{" "}
              <strong>non-returnable</strong> apart from the replacement of defective, damaged or
              missing items described on this page. Please check your order before you pay.
            </p>

            <h3 style={{ marginTop: 28 }}>Return shipping</h3>
            <p>
              For confirmed defective or non-working items, BIBA Electronics covers the cost
              of return shipping and the replacement shipment.
            </p>

            <h3 style={{ marginTop: 28 }}>How it works</h3>
            <p>
              Once we confirm the issue, we'll arrange pickup of the defective unit and ship
              a replacement. If the reported issue isn't confirmed as a manufacturing defect,
              we'll let you know before any pickup is arranged.
            </p>

            <h3 style={{ marginTop: 28 }}>Questions</h3>
            <p>
              Contact our team at{" "}
              <a href="mailto:info@bibaelectronics.com">info@bibaelectronics.com</a> or{" "}
              <a href="tel:+919561091506">+91 95610 91506</a> for any return or
              replacement request.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReturnPolicyPage;
